import { useState } from 'react';
import { useSurvey } from '../../context/SurveyContext';
import Logo from '../UI/Logo';
import LoadingScreen from './LoadingScreen';
import CongratulationsScreen from './CongratulationsScreen';
import PersonalizedResultsScreen from './PersonalizedResultsScreen';
import TransformationTimelineScreen from './TransformationTimelineScreen';
import SocialProofScreen from './SocialProofScreen';
import ProductOfferScreen from './ProductOfferScreen';

export default function ConversionBoosterContainer() {
  const { product, checkoutUrl, surveyData } = useSurvey();
  const [currentScreen, setCurrentScreen] = useState(1);

  // Check for skip parameter (development only)
  const urlParams = new URLSearchParams(window.location.search);
  const skipBoosters = urlParams.get('skip') === 'boosters';

  if (skipBoosters && checkoutUrl) {
    window.location.href = checkoutUrl;
    return null;
  }

  const handleContinue = () => {
    if (currentScreen < 6) {
      setCurrentScreen(currentScreen + 1);
      window.scrollTo(0, 0);
    } else {
      // Screen 6 (ProductOfferScreen) handles checkout redirect internally
      if (checkoutUrl) {
        window.location.href = checkoutUrl;
      }
    }
  };

  // Get user age from survey data for personalization
  const userAge = surveyData?.dateOfBirth ?
    new Date().getFullYear() - new Date(surveyData.dateOfBirth).getFullYear() :
    null;

  const screens = {
    1: <LoadingScreen onComplete={handleContinue} />,
    2: <CongratulationsScreen product={product} onContinue={handleContinue} />,
    3: <PersonalizedResultsScreen product={product} userAge={userAge} onContinue={handleContinue} />,
    4: <TransformationTimelineScreen product={product} onContinue={handleContinue} />,
    5: <SocialProofScreen product={product} onContinue={handleContinue} />,
    6: <ProductOfferScreen product={product} checkoutUrl={checkoutUrl} onContinue={handleContinue} />
  };

  return (
    <div className="min-h-screen bg-warm-beige">
      <div className="container mx-auto px-4 py-8">
        <Logo className="mb-8" />
        {screens[currentScreen]}
      </div>
    </div>
  );
}
